import type { DemandProductKey } from './types/DemandProductKey';

export const isSameProductKey = (first: DemandProductKey, second: DemandProductKey): boolean =>
    first.type === second.type && first.value === second.value;
